var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigurebuttonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 0L0.658333 1.175L4.475 5L0.658333 8.825L1.83333 10L6.83333 5L1.83333 0Z",
    fill: "#DAAA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurebuttonicon);
export default __webpack_public_path__ + "static/media/configurebuttonicon.955ad760934d751ba6056ed7a0756b2f.svg";
export { ForwardRef as ReactComponent };